// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation CloseBackorderMutation($input: CloseBackorderInput!) {
    closeBackorder(input: $input) {
      backorderEdge {
        node {
          id
          backorderNumber
          status
          expectedDate
          notes
          order {
            id
            orderNumber
          }
          customer {
            id
            name
          }
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, options);
  },
};
